<template>
  <div class="breadcrumb" v-if="breadcrumbList && breadcrumbList.length > 0">
    <ul>
      <li @click="routeTo(home)" class="linked">
        <q-img :src="require(`./assets/home.svg`)" alt="home" class="icon" />
        {{ home.name }}
      </li>
      <li
        v-for="(breadcrumb, idx) in breadcrumbList"
        :key="idx"
        @click="routeTo(breadcrumb)"
        :class="{ linked: !!breadcrumb.link }"
      >
        <!-- Flecha -->
        <q-img
          :src="require(`./assets/arrow-right.svg`)"
          alt="flecha derecha"
          class="icon"
        />
        {{ breadcrumb.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { QImg } from 'quasar';
import { mapGetters } from 'vuex';

export default {
  name: 'Breadcrumbs',
  components: {
    QImg
  },
  computed: {
    ...mapGetters({
      isAdmin: 'PF/isAdmin',
      isSuperAdmin: 'PF/isSuperAdmin',
      isExternal: 'PF/isExternal',
      haveEntidadesVisibles: 'PF/haveEntidadesVisibles',
      haveEntidadesVisiblesRelated: 'PF/haveEntidadesVisiblesRelated'
    })
  },
  data () {
    return {
      breadcrumbList: [],
      home: {
        name: 'Inicio',
        link: '/'
      }
    };
  },
  mounted () {
    this.updateList();
  },
  watch: {
    $route () {
      this.updateList();
    }
  },
  methods: {
    routeTo (breadcrumb) {
      if (breadcrumb.link && breadcrumb.link === '/indices-tematicos') {
        this.$router.back();
      } else if (breadcrumb.link) {
        if (breadcrumb.link === '/') {
          if (this.isSuperAdmin || this.isAdmin || this.isExternal) {
            if ((this.haveEntidadesVisibles && (this.isSuperAdmin || this.isAdmin)) ||
              (this.isExternal && this.haveEntidadesVisiblesRelated)) {
              breadcrumb.link = '/misServiciosDigitales';
            }
          }
        }

        if (this.$route.path !== breadcrumb.link) this.$router.push(breadcrumb.link);
      }
    },
    updateList () {
      this.breadcrumbList = this.$route.meta.breadcrumb;
    }
  }
};
</script>

<style scoped>
ul {
  display: flex;
  list-style-type: none;
  padding: 0;
}
li {
  margin: 1px 0 5px 3px;
  font-family: DINPro;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  color: #777;
  text-transform: uppercase;
}
.linked {
  cursor: pointer;
}
.icon {
  width: 24px;
  height: 24px;
}
</style>
